// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { border, maxWidth, minWidth, width } from '@mui/system';

const basemapStyles = {
  container: {
    position: 'relative',
  },

  panel: (active: boolean) => ({
    position: 'absolute',
    top: '0px',
    right: '40px',
    width: '250px',
    height: '240px',
    background: 'var(--calcite-ui-foreground-1)',
    boxShadow: 'var(--calcite-shadow-2)',
    borderRadius: '6px',
    padding: '8px',
    zIndex: '50',
    display: active ? 'block' : 'none',
  }),

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '6px',
    marginBottom: '6px',
    borderBottom: '1px solid var(--calcite-ui-border-2)',
  },

  headerTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: 'var(--calcite-ui-text-1)',
  },

  eyeToggle: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },

  basemapDiv: {
    width: '100%',
    height: 'calc(100% - 36px)',
    overflow: 'auto',
  },
};

export default basemapStyles;
